import { t } from "i18next";
import { AppInputSwitcher } from "../../components/Layouts/AppInputSwitcher/AppInputSwitcher";
import React, { useEffect, useRef, useState } from "react";
import BookingGetters from "../../store/onlineBooking/getters";
import { PaymentTypesDetails } from "../../components/Layouts/BookingForm/PaymentTypesDetails";
import { useTranslation } from "react-i18next";
import { TextResource } from "../../@types/DTO/AppSetting";
import i18n from "../../config/i18n";
import { useSearchParams } from "react-router-dom";

function NewPersonalDetails({
  reservationSourcePayNow,
  reservationSourcePayLater,
  extrasSelected,
  updateVehiclePrice,
  updateSelectedPrice,
  updateUserPrimaryDetails,
  updateVehiclePriceLater,
  firstName,
  lastName,
  email,
  phoneNo,
  emailError,
  emailRef,
  phoneRef,
  phoneError,
  onPaymentTypeChange,
  checkPaymentType,
  personalDetailsErrorText = {
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
  },
  setPersonalDetailsErrorText,
  readOnlyName = false,
}: any) {
  const { t: translate } = useTranslation();
  const appSettings = BookingGetters.getAppSettings();
  const [reservationCancelMsgInPayment, setReservationCancelMsgInPayment] =
    useState<String>("");
  const showOnePayMethodTwoPrice =
    appSettings && appSettings["showOnePayMethodTwoPrice"];
  const enableUppercaseInputField = appSettings?.enableUppercaseInputField;
  const isGretaBookingNewUi = appSettings?.isGretaBookingNewUi;

  const userId = localStorage.getItem("userID");
  // const isInvalidUser =
  //   !userId || userId === "null" || userId === "" || userId === "undefined";
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1510;
  const [searchParams] = useSearchParams();
  const scriptChannel = searchParams.get("scriptChannel") ?? "";
  const isInvalidScriptChannelResSource =
    searchParams.get("isInvalidScriptChannelResSource") == "true"
      ? true
      : false;

  const isPaymentModeAlreadyChosenAtSearch =
    (reservationSourcePayNow === "true" ||
      reservationSourcePayLater === "true") &&
    !isInvalidScriptChannelResSource;
  const hidePaymentSectionForCardChoice =
    appSettings?.showPaymentChoiceOnVehicleCard &&
    !isPaymentModeAlreadyChosenAtSearch;
  const handleChange = (key, value) => {
    updateUserPrimaryDetails(key, value);
    if (setPersonalDetailsErrorText && personalDetailsErrorText[key]) {
      isClearingErrorRef.current = true;
      setPersonalDetailsErrorText((prev: Record<string, string>) => ({
        ...prev,
        [key]: "",
      }));
    }
  };
  const [personalDetailsLabel, setPersonalDetailsLabel] = useState<String>("");
  const [personalDetailsLabelRes, setPersonalDetailsLabelRes] =
    useState<String>("");
  const [personalDetailsHeader, setPersonalDetailsHeader] =
    useState<string>("");
  const [paymentTypesDetailsHeader, setPaymentTypesDetailsHeader] =
    useState<string>("");
  const lang = i18n.language;
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const isSmallScreen = window.innerWidth <= 768;
  useEffect(() => {
    const dataMap = Object.fromEntries(
      (data ?? []).map((item) => [item.key, item.body])
    );
    setPersonalDetailsHeader(dataMap["personalDetailsHeader"] || "");
    setPersonalDetailsLabel(
      dataMap["personalDetailsLabel"] || translate("Personal Details")
    );
    setPersonalDetailsLabelRes(
      dataMap["personalDetailsLabelRes"] || "Dati Cliente"
    );
    const reservationCancelMsgInPaymentData = data.find(
      (item) => item.key === "reservationCancelMsgInPayment"
    )?.body;
    setReservationCancelMsgInPayment(reservationCancelMsgInPaymentData || "");
    setPaymentTypesDetailsHeader(dataMap["paymentTypesDetailsHeader"]);
  }, [textResource, lang, translate]);

  const [isDesktop] = useState(window.innerWidth >= 1300);

  const firstNameRef = useRef<any>(null);
  const lastNameRef = useRef<any>(null);
  const phoneContainerRef = useRef<HTMLDivElement>(null);

  const isClearingErrorRef = useRef(false);
  useEffect(() => {
    if (isClearingErrorRef.current) {
      isClearingErrorRef.current = false;
      return;
    }
    const {
      firstName: fnErr,
      lastName: lnErr,
      email: emErr,
      telephone: telErr,
    } = personalDetailsErrorText;
    if (fnErr && firstNameRef.current) {
      firstNameRef.current.focus();
    } else if (lnErr && lastNameRef.current) {
      lastNameRef.current.focus();
    } else if (emErr && emailRef?.current) {
      emailRef.current.focus();
    } else if (telErr) {
      const phoneInput =
        phoneContainerRef.current?.querySelector<HTMLInputElement>("input");
      phoneInput?.focus();
    }
  }, [personalDetailsErrorText]);

  return (
    <>
      {isGretaBookingNewUi ? (
        /* ── New Greta UI ── */
        <>
          <div className="rounded-2xl p-6 w-full">
            <h2
              className={"text-black text-base mt-2 font-medium "}
              dangerouslySetInnerHTML={{
                __html: String(personalDetailsHeader),
              }}
            />
            <h2 className="text-xl text-black pb-8 font-bold mt-[5px] ml-[20px]">
              {userId !== null && userId !== "null" && userId !== ""
                ? personalDetailsLabelRes
                : personalDetailsLabel}
            </h2>
            <div className="flex flex-col gap-3 w-full md:w-[69%]">
              <div className="rounded-xl  px-4 py-2 ">
                <AppInputSwitcher
                  type="text"
                  className="w-full box-border bg-white"
                  error={!!personalDetailsErrorText.firstName}
                  label={t("First Name")}
                  key="firstName"
                  value={firstName || ""}
                  onchange={(e: any) => handleChange("firstName", e.toString())}
                  inputRef={firstNameRef}
                  required={true}
                />
                {personalDetailsErrorText.firstName && (
                  <p className="text-red-500 text-sm mt-1">
                    {personalDetailsErrorText.firstName}
                  </p>
                )}
              </div>
              <div className="rounded-xl px-4 py-2 ">
                <AppInputSwitcher
                  type="text"
                  className="w-full box-border bg-white"
                  error={!!personalDetailsErrorText.lastName}
                  label={t("Last Name")}
                  key="lastName"
                  value={lastName || ""}
                  onchange={(e: any) => handleChange("lastName", e.toString())}
                  inputRef={lastNameRef}
                  required={true}
                />
                {personalDetailsErrorText.lastName && (
                  <p className="text-red-500 text-sm mt-1">
                    {personalDetailsErrorText.lastName}
                  </p>
                )}
              </div>
              <div className="rounded-xl  px-4 py-2 ">
                <AppInputSwitcher
                  type="email"
                  className="w-full box-border bg-white"
                  error={!!personalDetailsErrorText.email}
                  label={t("Email")}
                  key="email"
                  value={email || ""}
                  onchange={(e: any) => handleChange("email", e.toString())}
                  inputRef={emailRef}
                  required={true}
                />
                {personalDetailsErrorText.email && (
                  <p className="text-red-500 text-sm mt-1">
                    {personalDetailsErrorText.email}
                  </p>
                )}
              </div>
              <div className="rounded-xl  px-4 py-2 " ref={phoneContainerRef}>
                <AppInputSwitcher
                  type="mobile"
                  required={appSettings?.markPhoneNoRequiredForPrivate}
                  className="w-full box-border bg-white"
                  label={t("Mobile Number")}
                  key="telephone"
                  value={phoneNo || ""}
                  onchange={(e: any) => handleChange("telephone", e.toString())}
                  inputRef={phoneRef}
                />
                {personalDetailsErrorText.telephone && (
                  <p
                    style={{ color: "red", fontStyle: "italic" }}
                    className="text-sm mt-1"
                  >
                    {personalDetailsErrorText.telephone}
                  </p>
                )}
              </div>
            </div>
          </div>

          {(!appSettings?.showAllPayOptionsInResArea &&
            !showOnePayMethodTwoPrice) ||
          !!(scriptChannel && isInvalidScriptChannelResSource) ||
          (!showOnePayMethodTwoPrice &&
            reservationSourcePayNow === "false" &&
            reservationSourcePayLater === "false") ? (
            <div
              className={
                hidePaymentSectionForCardChoice
                  ? "w-full"
                  : "bg-gray-100 box-border border-y-2 pt-[30px] px-8 pb-[30px] mt-0 w-full"
              }
            >
              {!hidePaymentSectionForCardChoice &&
                paymentTypesDetailsHeader && (
                  <h2 className="text-xl text-black pb-8 font-bold">
                    {paymentTypesDetailsHeader}
                  </h2>
                )}
              <PaymentTypesDetails
                reservationSourcePayNow={reservationSourcePayNow}
                reservationSourcePayLater={reservationSourcePayLater}
                extrasPrice={extrasSelected?.extrasPrice}
                updateVehiclePrice={updateVehiclePrice}
                updateVehiclePriceLater={updateVehiclePriceLater}
                updateSelectedPrice={updateSelectedPrice}
                onPaymentTypeChange={onPaymentTypeChange}
                checkPaymentType={checkPaymentType}
              />
            </div>
          ) : (
            <>
              {reservationCancelMsgInPayment && (
                <div
                  className={`flex bg-white ${
                    isDesktop
                      ? "px-4 grow max-w-[30%] md:ml-4"
                      : "justify-center px-4 py-4 mb-4 md:mb-0 md:mr-4"
                  } text-sm relative`}
                >
                  <div
                    className={`flex-1 p-4 flex items-center justify-center text-center text-sm font-bold`}
                  >
                    <div>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: String(reservationCancelMsgInPayment),
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        /* ── Old UI (unchanged) ── */
        <>
          <div
            className={`bg-white box-border ${
              isSmallScreen ? "p-2" : "p-8"
            } justify-center`}
            style={{ paddingBottom: isSmallScreen ? "2rem" : "" }}
          >
            <h2
              className={"text-black text-base mt-2 font-medium "}
              dangerouslySetInnerHTML={{
                __html: String(personalDetailsHeader),
              }}
            />
            <h2
              className="text-xl text-black pb-8 font-bold mt-[5px]"
              style={{
                paddingLeft: isSmallScreen ? ".8rem" : "",
                paddingTop: isSmallScreen ? "2rem" : "",
              }}
            >
              {userId !== null && userId !== "null" && userId !== ""
                ? personalDetailsLabelRes
                : personalDetailsLabel}
            </h2>
            <div
              className={`grid sm:grid-cols-2 ${
                istabletScreen ? "md:grid-cols-2" : "md:grid-cols-3"
              } gap-4`}
            >
              <div>
                <AppInputSwitcher
                  type="text"
                  className={`h-20 sm:w-full box-border ${
                    isSmallScreen ? "px-2" : "px-8"
                  }`}
                  required={true}
                  error={!!personalDetailsErrorText.firstName}
                  label={t("First Name")}
                  key="firstName"
                  value={firstName || ""}
                  readOnly={readOnlyName}
                  inputRef={firstNameRef}
                  onchange={(e) =>
                    handleChange(
                      "firstName",
                      enableUppercaseInputField
                        ? e.toString().toUpperCase()
                        : e.toString()
                    )
                  }
                />
                {personalDetailsErrorText.firstName && (
                  <p
                    style={{ color: "red", fontStyle: "italic" }}
                    className={`text-sm -mt-4 ${
                      isSmallScreen ? "px-2" : "px-8"
                    }`}
                  >
                    {personalDetailsErrorText.firstName}
                  </p>
                )}
              </div>
              <div>
                <AppInputSwitcher
                  type="text"
                  required={true}
                  error={!!personalDetailsErrorText.lastName}
                  className={`h-20 sm:w-full box-border ${
                    isSmallScreen ? "px-2" : "px-8"
                  }`}
                  label={t("Last Name")}
                  key="lastName"
                  value={lastName || ""}
                  readOnly={readOnlyName}
                  inputRef={lastNameRef}
                  onchange={(e) =>
                    handleChange(
                      "lastName",
                      enableUppercaseInputField
                        ? e.toString().toUpperCase()
                        : e.toString()
                    )
                  }
                />
                {personalDetailsErrorText.lastName && (
                  <p
                    style={{ color: "red", fontStyle: "italic" }}
                    className={`text-sm -mt-4 ${
                      isSmallScreen ? "px-2" : "px-8"
                    }`}
                  >
                    {personalDetailsErrorText.lastName}
                  </p>
                )}
              </div>
              <div className="w-full">
                <AppInputSwitcher
                  type="email"
                  required={true}
                  className={`h-20 sm:w-full box-border ${
                    isSmallScreen ? "px-2" : "px-8"
                  }`}
                  error={!!emailError}
                  label={t("Email")}
                  key="email"
                  value={email || ""}
                  onchange={(e) =>
                    handleChange(
                      "email",
                      enableUppercaseInputField
                        ? e.toString().toUpperCase()
                        : e.toString()
                    )
                  }
                  // onchange={(e: any) => handleChange("email", e.toString())}
                  inputRef={emailRef}
                />
                {emailError && (
                  <p
                    style={{ color: "red", fontStyle: "italic" }}
                    className={`text-sm -mt-4 ${
                      isSmallScreen ? "px-2" : "px-8"
                    }`}
                  >
                    {emailError}
                  </p>
                )}
              </div>
              <div ref={phoneContainerRef}>
                <AppInputSwitcher
                  type="mobile"
                  required={appSettings?.markPhoneNoRequiredForPrivate}
                  className={`h-20 sm:w-full box-border ${
                    isSmallScreen ? "px-2" : "px-8"
                  }`}
                  error={!!phoneError}
                  label={t("Mobile Number")}
                  key="telephone"
                  value={phoneNo || ""}
                  onchange={(e: any) => handleChange("telephone", e.toString())}
                  inputRef={phoneRef}
                />
                {phoneError && (
                  <p
                    style={{ color: "red", fontStyle: "italic" }}
                    className={`text-sm -mt-4 ${
                      isSmallScreen ? "px-2" : "px-8"
                    }`}
                  >
                    {phoneError}
                  </p>
                )}
              </div>
            </div>
          </div>

          {!(userId && appSettings?.enableOnlyWireTransferForResArea) &&
          ((!appSettings?.showAllPayOptionsInResArea &&
            !showOnePayMethodTwoPrice) ||
            !!(scriptChannel && isInvalidScriptChannelResSource) ||
            (!showOnePayMethodTwoPrice &&
              reservationSourcePayNow === "false" &&
              reservationSourcePayLater === "false")) ? (
            <div
              className={
                hidePaymentSectionForCardChoice
                  ? "w-full ![display:none]"
                  : "bg-white box-border p-10"
              }
            >
              {!hidePaymentSectionForCardChoice &&
                paymentTypesDetailsHeader && (
                  <h2 className="text-xl text-black pb-8 font-bold">
                    {paymentTypesDetailsHeader}
                  </h2>
                )}
              <PaymentTypesDetails
                reservationSourcePayNow={reservationSourcePayNow}
                reservationSourcePayLater={reservationSourcePayLater}
                extrasPrice={extrasSelected?.extrasPrice}
                updateVehiclePrice={updateVehiclePrice}
                updateVehiclePriceLater={updateVehiclePriceLater}
                updateSelectedPrice={updateSelectedPrice}
                onPaymentTypeChange={onPaymentTypeChange}
                checkPaymentType={checkPaymentType}
              />
            </div>
          ) : (
            <>
              {reservationCancelMsgInPayment && (
                <div
                  className={`flex bg-white ${
                    isDesktop
                      ? "px-4 grow max-w-[30%] md:ml-4"
                      : "justify-center px-4 py-4 mb-4 md:mb-0 md:mr-4"
                  } text-sm relative`}
                >
                  <div className="flex-1 p-4 flex items-center justify-center text-center text-sm font-bold">
                    <div>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: String(reservationCancelMsgInPayment),
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}

export default NewPersonalDetails;
